// Gestion d'identité et persistance locale.
//
// Stratégie : on stocke un userId anonyme dans localStorage. Le backend
// (Modal) tient la source de vérité — on peut donc le retrouver depuis
// n'importe quel device si on lie userId à un email plus tard.

const USER_KEY = 'eteka.userId';
const SESSION_KEY = 'eteka.sessionId';

export interface SessionIds {
  userId: string;
  sessionId: string;
}

export function getOrCreateSession(): SessionIds {
  let userId = localStorage.getItem(USER_KEY);
  if (!userId) {
    userId = newId('user');
    localStorage.setItem(USER_KEY, userId);
  }
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = newId('sess');
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return { userId, sessionId };
}

export function resetSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
}

function newId(prefix: string): string {
  const rand = crypto.getRandomValues(new Uint8Array(8));
  const hex = Array.from(rand, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${prefix}_${Date.now().toString(36)}_${hex}`;
}
